define(['underscore', 'text!./templates/coverage-premiums.html'],
    (_, templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                scope: {
                    model: '=gwQnbCoveragePremiums',
                },
                template: templateStr,
                controller: ($scope) => {
                    $scope.buildingCoveragesByLocation = _.map(_.groupBy(
                        $scope.model.value.buildingCoverages,
                        buildingCoverage => buildingCoverage.building.locationId
                    ));
                },
            };
        }];
    });


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/CoveragePremiums.js